<div class="cr-container" *ngIf="data">

  <!-- ── 1. Datos de escritura ──────────────────────────────────────────── -->
  @if (shows('escritura')) {
    <section class="cr-section" aria-labelledby="cr-escritura-title">
      <h3 class="cr-section-title" id="cr-escritura-title">Datos de escritura</h3>
      <div class="cr-grid cr-grid-3">
        <div class="cr-field">
          <span class="cr-label">Fecha de escritura</span>
          <span class="cr-value">{{ data.escritura.fecha || '—' }}</span>
        </div>
        <div class="cr-field">
          <span class="cr-label">Concepto de escritura</span>
          <span class="cr-value">{{ data.escritura.concepto || '—' }}</span>
        </div>
        <div class="cr-field">
          <span class="cr-label">Notario</span>
          <span class="cr-value">{{ data.escritura.notario || '—' }}</span>
        </div>
        <div class="cr-field">
          <span class="cr-label">Protocolo</span>
          <span class="cr-value">{{ data.escritura.protocolo || '—' }}</span>
        </div>
        <div class="cr-field">
          <span class="cr-label">Provincia registro mercantil</span>
          <span class="cr-value">{{ data.escritura.provinciaRM || '—' }}</span>
        </div>
        <div class="cr-field">
          <span class="cr-label">Fecha inscripción</span>
          <span class="cr-value">{{ data.escritura.fechaInscripcion || '—' }}</span>
        </div>
        <div class="cr-field">
          <span class="cr-label">Tomo</span>
          <span class="cr-value">{{ data.escritura.tomo || '—' }}</span>
        </div>
        <div class="cr-field">
          <span class="cr-label">Folio</span>
          <span class="cr-value">{{ data.escritura.folio || '—' }}</span>
        </div>
        <div class="cr-field">
          <span class="cr-label">Hoja</span>
          <span class="cr-value">{{ data.escritura.hoja || '—' }}</span>
        </div>
        <div class="cr-field">
          <span class="cr-label">Sección</span>
          <span class="cr-value">{{ data.escritura.seccion || '—' }}</span>
        </div>
        <div class="cr-field">
          <span class="cr-label">Libro</span>
          <span class="cr-value">{{ data.escritura.libro || '—' }}</span>
        </div>
        <div class="cr-field">
          <span class="cr-label">Nº inscripción</span>
          <span class="cr-value">{{ data.escritura.numInscripcion || '—' }}</span>
        </div>
      </div>
    </section>
  }

  <!-- ── 2. Objeto Social ───────────────────────────────────────────────── -->
  @if (shows('objetoSocial')) {
    <section class="cr-section" aria-labelledby="cr-objeto-title">
      <h3 class="cr-section-title" id="cr-objeto-title">Objeto Social</h3>
      <div class="cr-grid cr-grid-2">
        <div class="cr-field">
          <span class="cr-label">Código CNAE</span>
          <span class="cr-value">
            @if (data.objetoSocial.codigoCnae) {
              {{ data.objetoSocial.codigoCnae }}{{ data.objetoSocial.nombreCnae ? ' - ' + data.objetoSocial.nombreCnae : '' }}
            } @else {
              —
            }
          </span>
        </div>
        <div class="cr-field cr-field--full">
          <span class="cr-label">Objeto Social</span>
          <span class="cr-value cr-value--multiline">{{ data.objetoSocial.descripcion || '—' }}</span>
        </div>
      </div>
    </section>
  }

  <!-- ── 3. Capital Social ──────────────────────────────────────────────── -->
  @if (shows('capitalSocial')) {
    <section class="cr-section" aria-labelledby="cr-capital-title">
      <h3 class="cr-section-title" id="cr-capital-title">Capital Social</h3>

      <div class="series-header">
        <div class="total-series-container" [class.center]="!data.capitalSocial.hasSeries">
          <span class="total-series-badge">
            <fa-icon [icon]="faNotes"></fa-icon>
            <span class="badge-label">Capital social total:</span>
            <span class="badge-value">{{ formatEuro(totalCapitalSocialEuro(data.capitalSocial)) }}</span>
          </span>
          <span class="total-series-badge">
            <fa-icon [icon]="faNotes"></fa-icon>
            <span class="badge-label">Total acciones:</span>
            <span class="badge-value">{{ formatShareAmount(data.capitalSocial.totalAcciones) }}</span>
          </span>
        </div>
      </div>

      @if (!data.capitalSocial.hasSeries) {
        <div class="columns is-multiline">
          <app-constitution-readonly-field
            label="Número de acciones total"
            [value]="formatShareAmount(data.capitalSocial.totalAcciones)"
            colSize="3"
          />
          <app-constitution-readonly-field
            label="Valor nominal"
            [value]="formatNominal(data.capitalSocial.valorNominal)"
            colSize="3"
          />
          <app-constitution-readonly-field
            label="Numeración acciones"
            [value]="formatNumeracion(data.capitalSocial.acccionesDesde, data.capitalSocial.accionesHasta)"
            colSize="6"
          />
        </div>
      } @else {
        <div class="card cr-card" role="region" aria-label="Series de capital social">
          <table class="table is-fullwidth is-striped is-hoverable cr-table" aria-label="Series">
            <thead>
              <tr>
                <th scope="col">Tipo / Serie</th>
                <th scope="col">Nº acciones</th>
                <th scope="col">Valor nominal</th>
                <th scope="col">Desde</th>
                <th scope="col">Hasta</th>
                <th scope="col">Capital social</th>
              </tr>
            </thead>
            <tbody>
              @for (serie of data.capitalSocial.series; track serie.nombre) {
                <tr class="is-clickable" (click)="openDetail({ type: 'serie', data: serie })">
                  <td>{{ serie.nombre }}</td>
                  <td>{{ formatShareAmount(serie.totalAcciones) }}</td>
                  <td>{{ formatNominal(serie.valorNominal) }}</td>
                  <td>{{ formatShareAmount(serie.desde) }}</td>
                  <td>{{ formatShareAmount(serie.hasta) }}</td>
                  <td><strong>{{ formatEuro(serie.capitalSocial) }}</strong></td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    </section>
  }

  <!-- ── 4. Socios ──────────────────────────────────────────────────────── -->
  @if (shows('socios')) {
    <section class="cr-section" aria-labelledby="cr-socios-title">
      <h3 class="cr-section-title" id="cr-socios-title">Socios</h3>
      @if (data.socios.length > 0) {
        <app-constitution-socios-readonly-table
          [socios]="data.socios"
          [capital]="data.capitalSocial"
          [partialLabel]="sociosParcial"
          (socioSelected)="onSocioSelected($event)"
        />
      } @else {
        <p class="cr-empty">Sin socios registrados.</p>
      }
    </section>
  }

  <!-- ── 5. Órgano de administración ───────────────────────────────────── -->
  @if (shows('administracion')) {
    <section class="cr-section" aria-labelledby="cr-admin-title">
      <h3 class="cr-section-title" id="cr-admin-title">Órgano de Administración</h3>
      <app-constitution-administration-readonly-table
        [administracion]="data.administracion"
        (memberSelected)="onMemberSelected($event)"
      />
    </section>
  }

  <!-- ── 6. Apoderados ─────────────────────────────────────────────────── -->
  @if (shows('apoderados')) {
    <section class="cr-section" aria-labelledby="cr-apoderados-title">
      <h3 class="cr-section-title" id="cr-apoderados-title">Apoderados</h3>
      <app-constitution-attorneys-readonly-table
        [apoderados]="data.apoderados"
        (attorneySelected)="onAttorneySelected($event)"
      />
    </section>
  }

</div>

<!-- ── Detail modal ───────────────────────────────────────────────────────── -->
@if (selectedDetail()) {
  <div
    class="modal is-active"
    role="dialog"
    aria-modal="true"
    [attr.aria-labelledby]="'cr-modal-title'"
  >
    <div class="modal-background" (click)="closeDetail()"></div>
    <div class="modal-card cr-detail-card" [class.wider-modal]="selectedDetail()!.type === 'socio' || selectedDetail()!.type === 'miembro'">

      <header class="modal-card-head">
        <p class="modal-card-title" id="cr-modal-title">
          @switch (selectedDetail()!.type) {
            @case ('socio')    { Detalle del socio }
            @case ('serie')    { Detalle de la serie }
            @case ('miembro')  { Detalle del miembro }
            @case ('apoderado'){ Detalle del apoderado }
          }
        </p>
        <button class="delete" type="button" aria-label="Cerrar" (click)="closeDetail()"></button>
      </header>

      <section class="modal-card-body">

        @if (selectedDetail()!.type === 'socio' && data) {
          <app-constitution-socios-readonly-detail
            [socio]="$any(selectedDetail()!.data)"
            [capital]="data.capitalSocial"
          />
        }

        <!-- Serie -->
        @if (selectedDetail()!.type === 'serie') {
          <div class="cr-detail-grid">
            <div class="cr-detail-field">
              <span class="cr-detail-label">Tipo / Serie</span>
              <span class="cr-detail-value">{{ $any(selectedDetail()!.data).nombre }}</span>
            </div>
            <div class="cr-detail-field">
              <span class="cr-detail-label">Nº acciones</span>
              <span class="cr-detail-value">{{ formatShareAmount($any(selectedDetail()!.data).totalAcciones) }}</span>
            </div>
            <div class="cr-detail-field">
              <span class="cr-detail-label">Valor nominal</span>
              <span class="cr-detail-value">{{ formatNominal($any(selectedDetail()!.data).valorNominal) }}</span>
            </div>
            <div class="cr-detail-field">
              <span class="cr-detail-label">Numeración desde</span>
              <span class="cr-detail-value">{{ formatShareAmount($any(selectedDetail()!.data).desde) }}</span>
            </div>
            <div class="cr-detail-field">
              <span class="cr-detail-label">Numeración hasta</span>
              <span class="cr-detail-value">{{ formatShareAmount($any(selectedDetail()!.data).hasta) }}</span>
            </div>
            <div class="cr-detail-field">
              <span class="cr-detail-label">Capital social de serie</span>
              <span class="cr-detail-value">{{ formatEuro($any(selectedDetail()!.data).capitalSocial) }}</span>
            </div>
          </div>
        }

        @if (selectedDetail()!.type === 'miembro') {
          <app-constitution-administration-readonly-detail
            [miembro]="$any(selectedDetail()!.data)"
            [sistemaRaw]="data?.administracion.sistemaRaw"
          />
        }

        @if (selectedDetail()!.type === 'apoderado') {
          <app-constitution-attorneys-readonly-detail
            [apoderado]="$any(selectedDetail()!.data)"
          />
        }

      </section>

      <footer class="modal-card-foot">
        <button class="button" type="button" (click)="closeDetail()">Cerrar</button>
      </footer>

    </div>
  </div>
}
